// @flow

import type {Effect} from '../../types'

import {
  take,
  call,
  put,
  select,
} from 'redux-saga/effects'
import {
  mapActions
} from '../actions'
import {mapSelectors} from '../selectors'
import {fetchServiceProvidersByText} from '../lib/fetchServiceProvidersByText'
import {ensureMapReady} from './ensureMapReady'

export function* searchPlaceEffect(): Effect {
  while (true) {
    const {payload: {text}} = yield take(mapActions.onPlaceSearch.id)
    yield call(ensureMapReady)
    const apiIndex: ApiIndex<MapApi> = yield select(mapSelectors.getApiIndex)
    const places: ServiceProvider[] = yield call(fetchServiceProvidersByText, apiIndex, text, 10)
    yield put(mapActions.setServiceProviders(places))
  }
}
